import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <p
    className={`font-mono text-xs font-semibold uppercase tracking-[0.22em] ${
      dark ? "text-teal-400" : "text-teal-700"
    }`}
  >
    {children}
  </p>
);

export const SectionHeading = ({ children, dark = false, className = "" }) => (
  <h2
    className={`mt-4 font-display text-3xl font-bold tracking-tight sm:text-4xl ${
      dark ? "text-white" : "text-navy"
    } ${className}`}
  >
    {children}
  </h2>
);
